






























































import { Component, Vue, Prop, State } from 'nuxt-property-decorator';

import BravadoInfiniteScrollBase from '@/components/common/BravadoInfiniteScroll/BravadoInfiniteScrollBase.vue';
import BravadoInfiniteScrollLoader from '@/components/common/BravadoInfiniteScroll/BravadoInfiniteScrollLoader.vue';
import DualRingLoader from '@/components/common/DualRingLoader.vue';
import HeaderMenuConnections from '@/components/global/HeaderMenu/HeaderMenuConnections/HeaderMenuConnections.vue';
import HeaderMenuNotificationsCard from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCard.vue';
import HeaderMenuNotificationsDateDivider from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsDateDivider.vue';
import HeaderMenuNotificationsEmpty from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsEmpty.vue';
import HeaderMenuNotificationsListTooltip from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsList/HeaderMenuNotificationsListTooltip.vue';

import { notificationTypes } from '@/components/global/HeaderMenu/HeaderMenuNotifications/constants';

import { groupNotificationsByDateDividers } from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsList/utils';

import { NotificationKind } from '@/types/graphql';
import type { INotificationsGroup } from '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsList/utils';
import type { ISettings } from '@/types';
import type { NotificationConnection, NotificationEdge } from '@/types/graphql';

@Component<HeaderMenuNotificationsList>({
  name: 'HeaderMenuNotificationsList',
  components: {
    BravadoInfiniteScrollBase,
    BravadoInfiniteScrollLoader,
    DualRingLoader,
    HeaderMenuConnections,
    HeaderMenuNotificationsCard,
    HeaderMenuNotificationsDateDivider,
    HeaderMenuNotificationsEmpty,
    HeaderMenuNotificationsListTooltip,
    IconCheck: () => import('@/components/Icon/Check.vue'),
    HeaderMenuNotificationsCardReferral: () =>
      import(
        '@/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardReferral.vue'
      ),
  },
  mounted() {
    this.addHandlers();
  },
  beforeDestroy() {
    this.removeHandlers();
  },
})
export default class HeaderMenuNotificationsList extends Vue {
  @State('settings') settings!: ISettings;

  @Prop({ default: false }) loadingFirstPage!: boolean;
  @Prop({ default: false }) loadingMore!: boolean;
  @Prop({ default: false }) hasUnread!: boolean;
  @Prop({ default: () => ({} as NotificationConnection) }) notifications!: NotificationConnection;
  @Prop({ required: true }) onReadAll!: () => Promise<void>;

  protected isHoveredOverReadAll = false;

  get actionNeededNotifications(): NotificationEdge[] {
    return this.notifications.edges.filter(edge => edge.node?.kind === NotificationKind.ActionNeeded);
  }

  get groupedNodes(): Record<string, INotificationsGroup> {
    const { specialUsers } = this.settings;

    const supportedNotifications = this.notifications.edges.filter(({ node }) => {
      // @ts-ignore
      const username = node?.referenceable?.user?.username;

      if (specialUsers.includes(username) && !specialUsers.includes(this.$auth.user!.username as string)) {
        return false;
      }

      return (
        node &&
        node.kind === NotificationKind.Common &&
        Object.values(notificationTypes).includes(node.type as typeof notificationTypes[keyof typeof notificationTypes])
      );
    });
    return this.notifications && groupNotificationsByDateDividers(supportedNotifications);
  }

  get isLoaderVisible(): boolean {
    return this.notifications?.pageInfo?.hasNextPage;
  }

  get hasNodes(): boolean {
    return !!this.notifications?.edges?.length;
  }

  get isEmpty(): boolean {
    return !this.loadingFirstPage && !this.hasNodes;
  }

  get infiniteScrollContainer(): string {
    return this.$device.isMobile
      ? '.header-menu-notifications-list__notifications'
      : '.header-menu-notifications-list__inner';
  }

  get readAllButtonStyle(): Record<string, boolean> {
    return {
      'js-prevent-handle-outside': true,
      'header-menu-notifications-list__read-all-button': true,
      'header-menu-notifications-list__read-all-button--disabled': !this.hasUnread,
    };
  }

  get isTooltipVisible(): boolean {
    if (!this.hasUnread) return false;

    return this.isHoveredOverReadAll;
  }

  addHandlers(): void {
    if (this.$device.isMobile) return;

    const readAllButton = this.$refs.readAllButton as HTMLElement;
    readAllButton.addEventListener('mouseenter', this.handleReadAllButtonEnter);
    readAllButton.addEventListener('mouseleave', this.handleReadAllButtonLeave);
  }

  removeHandlers(): void {
    if (this.$device.isMobile) return;

    const readAllButton = this.$refs.readAllButton as HTMLElement;
    readAllButton.removeEventListener('mouseenter', this.handleReadAllButtonEnter);
    readAllButton.removeEventListener('mouseleave', this.handleReadAllButtonLeave);
  }

  handleReadAllButtonEnter(): void {
    this.isHoveredOverReadAll = true;
  }

  handleReadAllButtonLeave(): void {
    this.isHoveredOverReadAll = false;
  }
}
